import React from 'react'
import Typography from '@mui/material/Typography'

export default function ContentHeader(props) {
    return (
        <section style={{ paddingLeft: '2vh' }}>
            <Typography sx={{mt: 1}}variant="h4" gutterBottom>{props.title}</Typography>
        </section >
    )
}